import { useMutation } from '@tanstack/react-query';
import fetch from './fetch';

function useSubmitChangeBankAccount() {
  const { cb, key } = fetch();

  const { mutateAsync, data, isLoading, isSuccess, isError } = useMutation(key, cb);

  return { fetch: mutateAsync, data, isLoading, isSuccess, isError };
}

export default useSubmitChangeBankAccount;
